<template>
  <div style="width: 100%; height: 100%">
    <div id="pie2"></div>
    <div id="zongzichan">
      <span>总资产</span><b>{{ all }}台</b>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";

export default {
  data() {
    return {
      myData: [
        { value: 12, name: "巡查车" },
        { value: 6, name: "扫地车" },
        { value: 8, name: "小轿车" },
        { value: 14, name: "其他车" },
      ],
      all: 0,
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
    };
  },
  methods: {
    groups(v) {
      this.searchItem.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.upf + "/screen/countCar",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        data = data.sort(function up(x, y) {
          return y.carNum - x.carNum;
        });
        this.myData = [];
        var all = 0;
        for (const i in data) {
          var obj = {
            value: data[i].carNum,
            name: data[i].carTypeName +' '+ data[i].carNum + "台",
          };
          this.myData.push(obj);
          all += data[i].carNum;
        }
        this.all = all;
        this.drawBar("pie2");
      });
    },
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById(id), "dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: ({d}%)",
        },
        legend: {
          // orient: "vertical",
          //图例组件
          left: 0, //图例组件离右边的距离
          orient: "vertical", //布局  纵向布局
          //width: 40, //图行例组件的宽度,默认自适应
          x: "left", //图例显示在右边
          itemWidth: 12, //图例标记的图形宽度
          itemHeight: 12, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["10%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5e7aff",
          "#1cc3e7",
          "#ef3cf6",
          "#1bc85e",
          "#e8d611",
          "#ed982a",
          "#32e347",
          "#f25454",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  mounted() {
    // this.drawBar("pie2");
    //this.getData();
  },
};
</script>
<style lang="">
#pie2 {
  width: 100%;
  height: calc(100% - 70px);
}
#zongzichan {
  font-size: 20px;
}
#zongzichan span {
  margin-right: 10px;
  background: #0856a5;
  border-radius: 20px;
  padding: 4px 10px;
  color: #9bdaee;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/abc/pie.vue